import curry from "../../lib/core/functional/curry";

const renderModule = curry(function renderModule(preact, _context, _deps, _altLoader) {
    const { hooks, h, Fragment } = preact;

    function Module({ isLoggedIn, isLiked, totalLikes, toggleLike }) {
        const [intLikes, setLikes] = hooks.useState(totalLikes);

        const onClick = hooks.useCallback(
            function (event) {
                const stopExecution = toggleLike(event);

                if (stopExecution) {
                    return false;
                }

                if (!isLoggedIn) {
                    return res;
                }

                if (isLiked) {
                    setLikes(intLikes - 1);
                } else {
                    setLikes(intLikes + 1);
                }

                return false;
            },
            [toggleLike, isLiked, intLikes, isLoggedIn]
        );

        return (
            <Fragment>
                <a
                    onClick={onClick}
                    class={`like-btn ${isLiked ? "unlike" : "like"}`}
                    href={isLoggedIn ? "javascript:;" : "/login"}
                    ariaLabel={isLiked ? "Dislike post" : "Like post"}
                >
                    <i class={`heart fa ${isLiked ? "fa-heart" : "fa-heart-o"}`}></i>
                </a>
                {intLikes > 0 ? (
                    <span class="like-label">
                        <span class="like-count"> {intLikes} </span>
                    </span>
                ) : null}
            </Fragment>
        );
    }

    return Module;
});

export default function likeButton({ preact }) {
    return renderModule(preact);
}
